import React from "react";
import { connect } from "react-redux";
import { getTranslate } from "react-localize-redux";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Alert,
  Button,
} from "reactstrap";
import axios from "axios";
import ReactTooltip from "react-tooltip";
import { isIE } from "react-device-detect";

import { getReportData } from "../../utils";
import { configActions } from "../../redux/actions";
import { RunTestReport } from "../../containers/AppPages/Reports/runTestReport";
import { CopyNewConfigReport } from "../../containers/AppPages/Reports/configuredReports/editConfigReport/CopyNewConfigReport";
import WizardFormFirstPage from "./WizardFormFirstPage";
import { WizardFormSecondPage } from ".";

import "./NewReportWizard.css";

class NewReportWizard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      isActive: true,
      internalUse: false,
      msg: {},
      savingReport: false,
      invalidFtpConfirmModal: false,
      keepOpen: false,
      showMoreDesc: false,
      selectedReportType:
        (props.config.reportsDescriptions &&
          props.config.reportsDescriptions.length > 0 &&
          props.config.reportsDescriptions[0]) ||
        "",
    };
  }

  nextPage = () => {
    this.setState({ page: this.state.page + 1 });
  };

  previousPage = () => {
    this.setState({ page: this.state.page - 1 });
  };

  handleSelectReportType = (item) => {
    this.setState({
      selectedReportType: item,
    });
  };

  handleActiveChange = () => {
    this.setState({
      isActive: !this.state.isActive,
    });
  };

  handleInternalUseChange = () => {
    this.setState({
      internalUse: !this.state.internalUse,
    });
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.isOpen !== this.props.isOpen) {
      // reset everything
      this.setState({
        page: 1,
        isActive: true,
        internalUse: false,
        selectedReportType:
          (this.props.config.reportsDescriptions &&
            this.props.config.reportsDescriptions.length > 0 &&
            this.props.config.reportsDescriptions[0]) ||
          "",
      });
    }
  }

  handleSaveClick = (keepOpen) => {
    const { handleOnSubmit } = this.props;
    const { isActive, internalUse, selectedReportType } = this.state;
    const formState = this.inputFormWiz.state;
    var me = this;
    const {
      ftpDeliveryState,
      sftpDeliveryState,
      ftpHost,
      ftpPort,
      ftpUserName,
      ftpUserPassword,
      ftpUploadPath,
    } = formState;

    this.setState({
      savingReport: true,
    });

    if (ftpDeliveryState || sftpDeliveryState) {
      if (ftpHost && ftpPort && ftpUserName && ftpUserPassword) {
        var params = {
          IsSFTP: sftpDeliveryState,
          Host: ftpHost,
          Port: ftpPort,
          Username: ftpUserName,
          Password: ftpUserPassword,
          Path: ftpUploadPath,
        };
        axios
          .post("Reporting/Pipelines/checkftpsftpconnection", params)
          .then((response) => {
            if (response.data.Errors && response.data.Errors.length) {
              // confirmation window
              me.setState({
                invalidFtpConfirmModal: true,
                keepOpen: keepOpen,
              });
            } else {
              // save without asking...
              handleOnSubmit(
                { ...formState, isActive, internalUse },
                selectedReportType,
                me.resetLoader,
                keepOpen
              );
            }
          });
      } else {
        this.setState({
          msg: {
            savingReport: false,
            header: "FTP/SFTP Check",
            message: (
              <Alert style={{ width: "650px" }} color="danger">
                The following fields are required for FTP/SFTP delivery
                configuration:
                <br />
                Host, Port, Username, and Password.
              </Alert>
            ),
          },
        });
      }
    } else {
      handleOnSubmit(
        { ...formState, isActive, internalUse },
        selectedReportType,
        this.resetLoader,
        keepOpen
      );
    }
  };

  resetLoader = () => {
    this.setState({
      savingReport: false,
    });
  };

  toggleMsgBox = () => {
    this.setState({
      msg: {},
    });
  };

  toggleInvalidFtpConfirmModal = () => {
    this.setState({
      invalidFtpConfirmModal: !this.state.invalidFtpConfirmModal,
    });
  };
  handleYesConfirmInvalidFtpDialog = () => {
    const { handleOnSubmit } = this.props;
    const { isActive, internalUse, selectedReportType } = this.state;
    const formState = this.inputFormWiz.state;
    handleOnSubmit(
      { ...formState, isActive, internalUse },
      selectedReportType,
      this.resetLoader,
      this.state.keepOpen
    );
    this.setState({
      invalidFtpConfirmModal: false,
    });
  };
  handleNoConfirmInvalidFtpDialog = () => {
    this.setState({
      savingReport: false,
      invalidFtpConfirmModal: false,
    });
  };

  toggleShowMoreDesc = (showMoreDesc) => {
    this.setState({
      showMoreDesc: showMoreDesc,
    });
  };

  handleCopyClick = () => {
    const { user, subUser, isSubUser, dispatch } = this.props;
    const { isActive, internalUse, selectedReportType } = this.state;
    const formState = this.inputFormWiz.state;
    const reportData = getReportData(
      { ...formState, isActive, internalUse },
      selectedReportType
    );
    let _report = JSON.parse(JSON.stringify(reportData.data));
    const { reportDefComponentsParams } = _report;
    if (
      reportDefComponentsParams &&
      reportDefComponentsParams.length &&
      reportDefComponentsParams[0].data
    ) {
      let _newRepDefCompParams = [...reportDefComponentsParams];
      let currentUser = user;
      if (isSubUser) {
        currentUser = subUser;
      }
      const copySuffixText = ` (copy by ${currentUser?.userId})`;
      _newRepDefCompParams[0].data.reportName =
        (_newRepDefCompParams[0].data?.reportName || "") + copySuffixText;
      _report = { ..._report, reportDefComponentsParams: _newRepDefCompParams };
    }
    dispatch(
      configActions.toggleCopyNewConfigReportModal(
        true,
        _report,
        selectedReportType
      )
    );
  };

  tooltipOverridePosition = ({ left, top }) => {
    if (isIE) {
      const vw = Math.max(
        document.documentElement.clientWidth || 0,
        window.innerWidth || 0
      );
      left = left + vw / 2 - 375;
      top = top + 25;
    }
    return { top, left };
  };

  render() {
    const {
      config,
      selectedNewReportCustomer,
      isOpen,
      translate,
      /* user,
      subUser, */
      isSubUser,
    } = this.props;
    const { page } = this.state;

    /* var currentUser = user;
    if (isSubUser) {
      currentUser = subUser;
    } */

    var inputData =
      ((this.inputFormWiz || {}).state || {}).params ||
      (
        (
          (
            (((config || {}).reportForEdit || {}).reportDefComponentsParams ||
              {})[0] || {}
          ).data || {}
        ).scriptparams || {}
      ).inputData ||
      {};

    return (
      <Modal
        style={
          page === 2 && this.state.showMoreDesc
            ? { maxWidth: "unset" }
            : { maxWidth: "750px" }
        }
        isOpen={isOpen}
      >
        <div className="modal-header">
          <h5 className="modal-title">
            {translate("Report creation wizard - step")} {this.state.page}
          </h5>
          {this.state.page === 2 && (
            <>
              <div
                className="active-wizard"
                //style={{ float: "right", margin: "0rem -12rem 0rem auto" }}
                style={{ textAlign: "end", margin: "0 1em 0 0", flex: 1 }}
              >
                <input
                  type="checkbox"
                  id="isActiveReport"
                  checked={this.state.isActive}
                  style={{ margin: "5px" }}
                  onChange={this.handleActiveChange.bind(this)}
                />
                <label
                  htmlFor="isActiveReport"
                  style={{ marginTop: "3px" }}
                  className="form-check-label"
                >
                  {translate("Active")}
                </label>
              </div>
              {!isSubUser && (
                <div className="active-wizard">
                  <input
                    type="checkbox"
                    id="internalUse"
                    checked={this.state.internalUse}
                    style={{ margin: "5px" }}
                    onChange={this.handleInternalUseChange}
                  />
                  <label
                    htmlFor="internalUse"
                    style={{ marginTop: "3px" }}
                    className="form-check-label"
                  >
                    {translate("Internal use only")}
                  </label>
                </div>
              )}
            </>
          )}
          <button
            type="button"
            onClick={this.props.toggle}
            className="close"
            aria-label="Close"
          >
            <span aria-hidden="true">{String.fromCharCode(215)}</span>
          </button>
        </div>
        <ModalBody style={{ backgroundColor: "#d9d9d9", padding: "1px" }}>
          {page === 1 && (
            <WizardFormFirstPage
              onSubmit={this.nextPage}
              selectedReportType={this.state.selectedReportType}
              handleSelectReportType={this.handleSelectReportType}
              isExternalUser={!!isSubUser}
              reportsDescriptions={config.reportsDescriptions}
              translate={translate}
            />
          )}
          {page === 2 && (
            <WizardFormSecondPage
              ref={(inputFormWiz) => {
                this.inputFormWiz = inputFormWiz;
              }}
              selectedReportType={this.state.selectedReportType}
              channels={config.channels}
              customers={config.customers}
              availableTimeZones={this.props.availableTimeZones}
              user={this.props.user}
              subUser={this.props.subUser}
              isSubUser={isSubUser}
              translate={translate}
              selectedCustomer={selectedNewReportCustomer}
              toggleShowMoreDesc={this.toggleShowMoreDesc}
              showMoreDesc={this.state.showMoreDesc}
              isActive={this.state.isActive}
            />
          )}
        </ModalBody>
        <ModalFooter style={{ display: "flex" }}>
          {page === 1 && (
            <div className="text-center" style={{ flex: 1 }}>
              <button
                type="button"
                className="btn btn-primary"
                onClick={this.nextPage}
              >
                {translate("Next")}
              </button>
            </div>
          )}
          {page !== 1 && (
            <>
              <div className="text-center" style={{ flex: 1 }}>
                <button
                  type="button"
                  disabled={this.state.savingReport}
                  className="btn btn-secondary"
                  onClick={this.previousPage}
                >
                  {translate("Back")}
                </button>
                <button
                  type="button"
                  disabled={this.state.savingReport}
                  className="btn btn-primary"
                  style={{ marginLeft: "15px" }}
                  onClick={() => this.handleSaveClick(true)}
                >
                  {translate("Save")}
                </button>
                <button
                  type="button"
                  disabled={this.state.savingReport}
                  className="btn btn-primary"
                  style={{ marginLeft: "15px" }}
                  onClick={() => this.handleSaveClick(false)}
                >
                  {translate("Save and close")}
                </button>
                <RunTestReport
                  reportDefinitionId={this.props.reportDefinitionId}
                  reportPipelineDefinitionId={
                    this.props.reportPipelineDefinitionId
                  }
                  customerId={inputData.customer}
                  project={inputData.project}
                  projects={inputData.projects}
                  channel={inputData.channel}
                  timezone={inputData.timezone}
                  disabled={this.state.savingReport}
                  closeParentModal={this.props.toggle}
                />
                {this.state.savingReport && (
                  <img
                    alt=""
                    style={{ float: "left", padding: "12px 12px" }}
                    src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="
                  />
                )}
              </div>
              {this.props.reportDefinitionId && (
                <div>
                  <button
                    className="add-issue-btn"
                    style={{ marginTop: "3px" }}
                    data-tip
                    data-place="left"
                    data-type="info"
                    data-effect="solid"
                    data-for="editCloneBtn"
                    onClick={this.handleCopyClick}
                  >
                    <i
                      className="fa fa-clone"
                      style={{ padding: "0 10px", fontSize: "1.3em" }}
                    />
                  </button>
                  <ReactTooltip
                    className="customeTheme"
                    id="editCloneBtn"
                    overridePosition={this.tooltipOverridePosition}
                  >
                    <strong>{translate("Clone")}</strong>
                  </ReactTooltip>
                </div>
              )}
            </>
          )}
        </ModalFooter>
        <Modal
          isOpen={!!this.state.msg.message}
          style={{ maxWidth: "700px", maxHeight: "700px" }}
          toggle={this.toggleMsgBox}
        >
          {this.state.msg.header && (
            <ModalHeader toggle={this.toggleMsgBox}>
              {this.state.msg.header}
            </ModalHeader>
          )}
          <ModalBody>{this.state.msg.message}</ModalBody>
          <ModalFooter className="text-center">
            <Button
              color="primary"
              className="switchBtn"
              style={{ width: "100px" }}
              onClick={this.toggleMsgBox}
            >
              {translate("OK")}
            </Button>
          </ModalFooter>
        </Modal>
        <Modal
          isOpen={this.state.invalidFtpConfirmModal}
          toggle={this.toggleInvalidFtpConfirmModal}
        >
          <ModalHeader toggle={this.toggleInvalidFtpConfirmModal}>
            {translate("FTP_SFTP Connection Checking")}
          </ModalHeader>
          <ModalBody>
            <Alert color="warning">
              {translate("FTP_SFTP checking failed")}"
            </Alert>
          </ModalBody>
          <ModalFooter className="text-center">
            <Button
              color="secondary"
              style={{ width: "90px" }}
              onClick={this.handleYesConfirmInvalidFtpDialog}
            >
              {translate("Yes")}
            </Button>
            <Button
              color="primary"
              className="EventSearchSubmit"
              style={{ marginLeft: "60px", width: "90px" }}
              onClick={this.handleNoConfirmInvalidFtpDialog}
            >
              {translate("No")}
            </Button>
          </ModalFooter>
        </Modal>
        {config.modalCopyNewConfigReport && (
          <CopyNewConfigReport
            isActive={this.state.isActive}
            isExternalUser={isSubUser}
            internalUse={this.state.internalUse}
            closeParentModal={this.props.toggle}
            handlePageReload={this.props.handlePageReload}
          />
        )}
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  const {
    config,
    locale,
    authentication,
    settings: { availableTimeZones },
    reports: { selectedNewReportCustomer },
  } = state;
  const { user, subUser, isSubUser } = authentication;
  return {
    user,
    subUser,
    isSubUser,
    config,
    availableTimeZones,
    selectedNewReportCustomer,
    translate: getTranslate(locale),
  };
}

const connectedNewReportWizard = connect(mapStateToProps)(NewReportWizard);
export { connectedNewReportWizard as NewReportWizard };
